/**
 * External dependencies
 */
import { __experimentalRegisterProductCollection as registerProductCollection } from '@woocommerce/blocks-registry';
import { __ } from '@wordpress/i18n';
import { Icon, scheduled } from '@wordpress/icons';

/**
 * Default inner block template for product collections.
 */
const INNER_BLOCKS_PRODUCT_TEMPLATE = [
	'woocommerce/product-template',
	{},
	[
		[
			'woocommerce/product-image',
			{
				imageSizing: 'thumbnail',
			},
		],
		[
			'core/post-title',
			{
				textAlign: 'center',
				level: 3,
				fontSize: 'medium',
				style: {
					spacing: {
						margin: {
							bottom: '0.75rem',
							top: '0',
						},
					},
				},
				isLink: true,
				__woocommerceNamespace: 'core/post-title/product-title',
			},
		],
		[
			'woocommerce/product-price',
			{
				textAlign: 'center',
				fontSize: 'small',
			},
		],
		[
			'woocommerce-bookings/booking-location',
			{
				textAlign: 'center',
			},
		],
		[
			'woocommerce/product-button',
			{
				textAlign: 'center',
				fontSize: 'small',
			},
		],
	],
];

/**
 * Construct the inner blocks for the collection.
 */
const heading = [
	'core/heading',
	{
		textAlign: 'center',
		level: 2,
		content: __( 'Services', 'woocommerce-bookings' ),
		style: { spacing: { margin: { bottom: '1rem' } } },
	},
];
const innerBlocks = [ heading, INNER_BLOCKS_PRODUCT_TEMPLATE ];

/**
 * Setup Attributes.
 */
const attributes = {
	displayLayout: {
		type: 'flex',
		columns: 5,
		shrinkColumns: true,
	},
	query: {
		perPage: 5,
		pages: 1,
	},
	hideControls: [ 'filterable', 'inherit', 'hand-picked' ],
};

/**
 * Arguments to register the collection.
 */
const collection = {
	name: 'woocommerce-bookings/product-collection/services',
	title: __( 'Services', 'woocommerce-bookings' ),
	icon: <Icon icon={ scheduled } />,
	description: __(
		'Display a list of bookable service products.',
		'woocommerce-bookings'
	),
	keywords: [ 'services', 'bookable', 'product collection' ],
	scope: [ 'block', 'inserter' ],
};

/**
 * Construct and export.
 */
const servicesCollectionData = {
	...collection,
	attributes,
	innerBlocks,
};

/**
 * Register product collection type.
 */
registerProductCollection( servicesCollectionData );
